import React from 'react'

import { GenericAnalyticsClient, withAnalyticsClient } from '@acorns/web-utils'
import { compose, defaultProps, lifecycle } from 'recompose'

import defaults from './defaults'
import verifyRender from './verifyRender'
import withFields from './withFields'

type Props = {
  defaultFields?: object
  fields: object
}

type EnhancedProps = Props & {
  analytics: GenericAnalyticsClient
}

const enhance = compose<EnhancedProps, Props>(
  withAnalyticsClient,
  defaultProps({
    defaultFields: defaults('Container Rendered'),
    fields: {},
  }),
  lifecycle<EnhancedProps, {}>({
    componentDidMount() {
      if (verifyRender(this)) {
        this.props.analytics.track('Container Rendered', {
          ...this.props.defaultFields,
          ...this.props.fields,
        })
      }
    },
  }),
)

export const TrackRendered = enhance((props) => <>{props.children}</>)

export const withTrackRendered = (customFields: object) =>
  compose(withFields(customFields), enhance)
